module.exports = __webpack_public_path__ + "img/cleanser_pop_science.268cd499.png";